export const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = 1000 * 60 * 60 * 24;

export const DEFAULT_QUERY_OPTIONS = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  keepPreviousData: true,
  staleTime: ONE_HOUR
};
